import { db } from './db.js'

async function cleanupShifts(currentShiftUUID) {
  try {
    const tx = db.transaction('shifts')
    let allTrx = await tx.store.getAll()
    for await (const cursor of allTrx) {
      //console.log('CLEANUP TRX:', currentShiftUUID, cursor)
      if (cursor.uuid === currentShiftUUID || cursor.syncneeded) continue
      else {
        await db.delete('transactions', cursor.uuid)
      }
    }
  } catch (e) {
    console.log('cleanupTransactions', e)
  }
}

async function getUnsyncedShifts() {
  try {
    const index = db.transaction('shifts').store.index('syncneeded')
    const keyRangeValue = IDBKeyRange.bound(1, 1, false, false)
    let cursors = await index.getAll(keyRangeValue)
    return cursors
  } catch (e) {
    return []
  }
}

async function getLastShift() {
  try {
    const indexLast = db.transaction('shifts').store.index('shiftStart')
    let cursors = await indexLast.openCursor(null, 'prev')
    return cursors?.value || null
  } catch (e) {
    return []
  }
}

async function storeShift(shift) {
  let shiftObj = JSON.parse(JSON.stringify(shift))
  if (db == null) return null
  if (shiftObj.syncneeded == null) shiftObj.syncneeded = 0
  try {
    if(shiftObj.shiftStart && typeof shiftObj.shiftStart !== 'string') shiftObj.shiftStart = new Date(shiftObj.shiftStart).toISOString()
    if(shiftObj.shiftEnd && typeof shiftObj.shiftEnd !== 'string') shiftObj.shiftEnd = new Date(shiftObj.shiftEnd).toISOString()
    await db.put('shifts', shiftObj)
  } catch (e) {
    console.log('put error shift', e)
  }
}

export {
  storeShift,
  getUnsyncedShifts,
  getLastShift,
  cleanupShifts
}